// extracted by mini-css-extract-plugin
export default {"homeSwiper":"Home_homeSwiper__g5qpn","ltrSwiper":"Home_ltrSwiper__0WtK6","rtlSwiper":"Home_rtlSwiper__tbcox"};